import React from "react";
import { Link } from "@reach/router";

import SvgGit from "../../../images/svg/github-icon.inline.svg";
import SvgLinkedin from "../../../images/svg/linkedin-icon-2.inline.svg";
import SvgAbout from "../../../images/svg/about.inline.svg";
import SvgProjects from "../../../images/svg/projects.inline.svg";

const classes = require("./Button.module.scss");

const Button = (props: { label: string; svgName?: string; path: string }) => {
    const svgBtnStyle = {
        height: "20px",
        width: "20px",
        marginRight: "10px",
    };

    const svgSelector = svgName => {
        switch (svgName) {
            case "git":
                return <SvgGit style={svgBtnStyle} />;

            case "linkedin":
                return <SvgLinkedin style={svgBtnStyle} />;

            case "about":
                return <SvgAbout style={svgBtnStyle} />;

            case "projects":
                return <SvgProjects style={svgBtnStyle} />;

            default:
                return null;
        }
    };

    return (
        <Link to={props.path} className={classes.btn}>
            {svgSelector(props.svgName)}
            {props.label}
        </Link>
    );
};

export default Button;
